import { Skeleton, Spin } from "antd";
import { onboardingStatus } from "api/generated";
import { useClient } from "hooks/useClient";
import { getUserRole, UserRole } from "hooks/useLoggedUser";
import { useEffect, useState } from "react";
import {
  CV_CONTEXT_PATH,
  getTokenData,
  returnToRegister,
  ToFirstContainerRegistry,
  ToFirstWarehouseRegistry,
} from "security";

function CheckStatusPage() {
  const { client } = useClient();
  const [isloading, setIsLoading] = useState(false);

  useEffect(() => {
    onboardingStatus({ client })
      .then(({ data }) => {
        if (data) {
          const onboarding: boolean =
            !data.companyRegistered ||
            !data.firstWarehouseRegistered ||
            !data.firstContainerRegistered;
          if (onboarding) {
            if (!data.companyRegistered) {
              returnToRegister();
            } else if (!data.firstWarehouseRegistered) {
              ToFirstWarehouseRegistry();
            } else if (!data.firstContainerRegistered) {
              ToFirstContainerRegistry();
            }
          } else {
            const tokenData = getTokenData() as {
              userRole: string;
            };
            const role = getUserRole(tokenData.userRole);
            if (role === UserRole.ADMINISTRADOR) {
              window.location.replace(`${CV_CONTEXT_PATH}/distributionPoints/`);
            } else {
              window.location.replace(`${CV_CONTEXT_PATH}/containers/`);
            }
          }
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [client]);

  return (
    <Spin spinning={isloading}>
      <Skeleton active />
    </Spin>
  );
}

export default CheckStatusPage;
